module.exports = "/_next/static/images/monitor-monotone-3fd0ba8bee02705a807cac6a5701032f.svg";